module.exports = __webpack_public_path__ + "media/images/oxfam-40d4ae522b8cfa812eee757b4a8666bc.png";